import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Form, Input, Typography, Row, Col } from 'antd';
import { useToast } from '../../contexts/ToastContext';
import { 
  UserOutlined, 
  LockOutlined, 
  MailOutlined, 
  StarOutlined
} from '@ant-design/icons';
import { apiService } from '../../services/api';
import '../../styles/colors.css';

const { Title, Text } = Typography;

const RegisterMentor: React.FC = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const result = await apiService.registerMentor(values);
      if (result.success) {
        toast.success('Mentor kaydı başarılı!');
        navigate('/login/mentor');
      } else {
        toast.error(result.message || 'Kayıt başarısız!');
      }
    } catch (error: any) {
      console.error('Register error:', error);
      const errorMessage = error?.response?.data?.message || 'Kayıt sırasında bir hata oluştu!';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Form validation failed:', errorInfo);
    toast.error('Lütfen tüm alanları doğru şekilde doldurun!');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-primary)',
      display: 'flex'
    }}>
      <Row style={{ width: '100%', minHeight: '100vh', margin: 0 }}>
        {/* Sol Taraf - Görsel */}
        <Col xs={0} lg={12} style={{ 
          background: 'linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '50%',
          height: '100vh',
          overflow: 'hidden',
          zIndex: 1
        }}>
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: 'white',
            zIndex: 2
          }}>
            <div style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 32px',
              fontSize: '3rem',
              fontWeight: 'bold',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(255,255,255,0.3)'
            }}>
              <StarOutlined style={{ fontSize: '3rem' }} />
            </div>
            <Title level={1} style={{ 
              color: 'white',
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '16px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              Mentor Ol
            </Title>
            <Text style={{ 
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.3rem',
              fontWeight: '500',
              marginBottom: '40px',
              display: 'block'
            }}>
              Bilginizi paylaşın, fark yaratın
            </Text>

            {/* Mentor Faydaları */}
            <div style={{ 
              textAlign: 'left', 
              marginTop: '32px',
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '16px',
              padding: '24px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Deneyiminizi paylaşın ve gelir elde edin
                </Text>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Danışanlarınızla bire bir çalışın
                </Text>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Bootcamp ve etkinlikler düzenleyin
                </Text>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Profesyonel ağınızı genişletin
                </Text>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Esnek çalışma saatleri belirleyin
                </Text>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center'
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.9)',
                  marginRight: '12px',
                  flexShrink: 0
                }} />
                <Text style={{ 
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Reklamlarınızı yayınlayın
                </Text>
              </div>
            </div>
          </div>
          
          {/* Dekoratif Elementler */}
          <div style={{
            position: 'absolute',
            top: '20%',
            right: '10%',
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.1)',
            zIndex: 1
          }} />
          <div style={{
            position: 'absolute',
            bottom: '20%',
            left: '15%',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            zIndex: 1
          }} />
        </Col>

        {/* Sağ Taraf - Form */}
        <Col xs={24} lg={12} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px',
          background: 'var(--bg-primary)',
          marginLeft: '50%',
          minHeight: '100vh',
          maxHeight: '100vh',
          overflowY: 'auto'
        }}>
          <div style={{ width: '100%', maxWidth: '500px' }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <Title level={2} style={{ 
                marginBottom: '8px',
                color: 'var(--text-primary)',
                fontSize: '2.2rem',
                fontWeight: '700'
              }}>
                Mentor Kaydı
              </Title>
              <Text style={{ 
                color: 'var(--text-secondary)',
                fontSize: '1.1rem'
              }}>
                Uzmanlığınızı paylaşın ve mentee'lere rehberlik edin
              </Text>
            </div>

            <Form
              name="register-mentor"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="firstName"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>Ad</span>}
                rules={[
                  { required: true, message: 'Adınızı girin!' },
                  { max: 100, message: 'Ad en fazla 100 karakter olabilir!' }
                ]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="Adınız"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item
                name="lastName"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>Soyad</span>}
                rules={[
                  { required: true, message: 'Soyadınızı girin!' },
                  { max: 100, message: 'Soyad en fazla 100 karakter olabilir!' }
                ]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="Soyadınız"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item
                name="email"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>E-posta</span>}
                rules={[
                  { required: true, message: 'E-posta adresinizi girin!' },
                  { type: 'email', message: 'Geçerli bir e-posta adresi girin!' }
                ]}
              >
                <Input
                  prefix={<MailOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="E-posta adresiniz"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item
                name="phoneNumber"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>Telefon Numarası</span>}
                rules={[
                  { required: true, message: 'Telefon numaranızı girin!' },
                  { pattern: /^[0-9+\-\s()]+$/, message: 'Geçerli bir telefon numarası girin!' }
                ]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="+90 5XX XXX XX XX"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>Şifre</span>}
                rules={[
                  { required: true, message: 'Şifrenizi girin!' },
                  { min: 6, message: 'Şifre en az 6 karakter olmalı!' }
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="Şifreniz"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label={<span style={{ color: 'var(--text-primary)', fontWeight: '600', fontSize: '0.95rem' }}>Şifre Tekrar</span>}
                dependencies={['password']}
                rules={[
                  { required: true, message: 'Şifrenizi tekrar girin!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Şifreler eşleşmiyor!'));
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined style={{ color: 'var(--primary-600)' }} />}
                  placeholder="Şifrenizi tekrar girin"
                  style={{ 
                    borderRadius: '12px',
                    height: '50px',
                    fontSize: '1rem'
                  }}
                />
              </Form.Item>

              <Form.Item style={{ marginTop: '32px' }}>
                <Button
                  className="btn-primary"
                  htmlType="submit"
                  loading={loading}
                  style={{
                    width: '100%',
                    height: '52px',
                    borderRadius: '12px',
                    fontSize: '1.1rem',
                    fontWeight: '600'
                  }}
                >
                  Mentor Olarak Kayıt Ol
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <Text style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                Zaten hesabınız var mı?{' '}
                <Link 
                  to="/login/mentor" 
                  style={{ 
                    color: 'var(--primary-600)', 
                    fontWeight: '600',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--primary-700)'}
                  onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--primary-600)'}
                >
                  Giriş Yap
                </Link>
              </Text>
            </div>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Text style={{ color: 'var(--text-tertiary)', fontSize: '0.9rem' }}>
                Mentör değil misiniz?{' '}
                <Link 
                  to="/register-mentee" 
                  style={{ 
                    color: 'var(--primary-600)',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--primary-700)'}
                  onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--primary-600)'}
                >
                  Mentee kayıt
                </Link>
                {' | '}
                <Link 
                  to="/register-company" 
                  style={{ 
                    color: 'var(--primary-600)',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--primary-700)'}
                  onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--primary-600)'}
                >
                  Kurumsal kayıt
                </Link>
              </Text>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RegisterMentor;
